export const useNotificationsStore = defineStore('notifications', () => {
    // State
    const notifications = ref([])

    // Getters
    const getAllNotifications = computed(() => notifications.value)

    // Actions
    const makeNotification = (message, level = 'info') => {
        const n = { message, level, visible: true }
        notifications.value.unshift(n)
    }

    const hideNotification = (n) => {
        n.visible = false
    }

    return {
        notifications,
        getAllNotifications,
        makeNotification,
        hideNotification,
    }
})
